module.exports = __webpack_public_path__ + "img/banner-fr.982b2c1c.png";